import { xyCumulativeDistributionStatistics } from 'ml-spectra-processing';

export function getStats(spectrum) {
  let stats = {};
  if (spectrum.variables.x && spectrum.variables.y) {
    let data = {
      x: spectrum.variables.x.data,
      y: spectrum.variables.y.data,
    };

    const weightStats = xyCumulativeDistributionStatistics(data);
    stats.weight = {
      diameter25: weightStats.x25,
      diameter50: weightStats.x50,
      diameter75: weightStats.x75,
      diameterMode: weightStats.xMode,
      diameterMean: weightStats.xMean,
      diameterWidth50: weightStats.x75 - weightStats.x25,
    };
  }

  if (spectrum.variables.x && spectrum.variables.n) {
    let data = {
      x: spectrum.variables.x.data,
      y: spectrum.variables.n.data,
    };
    const numberStats = xyCumulativeDistributionStatistics(data);
    stats.number = {
      diameter25: numberStats.x25,
      diameter50: numberStats.x50,
      diameter75: numberStats.x75,
      diameterMode: numberStats.xMode,
      diameterMean: numberStats.xMean,
      diameterWidth50: numberStats.x75 - numberStats.x25,
    };
  }
  return stats;
}
